import React, { useState, useContext } from "react";
import { Link as RouterLink } from "react-router-dom";
import { 
  Container, 
  CssBaseline, 
  Typography, 
  Button, 
  TextField, 
  Paper,
  Link,
  CircularProgress
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { MailOutline } from "@material-ui/icons";
import { openApi } from "../../services/api";
import ColorModeContext from "../../layout/themeContext";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#00B2FF",
    backgroundImage: "linear-gradient(326deg, rgba(0, 178, 255, 1) 0%, rgba(0, 70, 249, 1) 50%, rgba(0, 4, 25, 1) 100%)",
  },
  paper: {
    padding: theme.spacing(6),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "16px",
    textAlign: "center",
    maxWidth: "400px",
    width: "90%",
    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1)",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    padding: "10px 30px",
    borderRadius: "8px",
  },
}));

const PasswordForget = () => {
  const classes = useStyles();
  const { colorMode } = useContext(ColorModeContext);
  const { appName, appLogoFavicon } = colorMode;
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return toast.error("Digite seu e-mail.");
    setLoading(true);
    try {
      await openApi.post("/auth/password-forget", { email });
      toast.success("E-mail de recuperação enviado! Verifique sua caixa de entrada.");
      setEmail("");
    } catch (err) {
      toast.error(err.response?.data?.error || "Erro ao enviar e-mail.");
    }
    setLoading(false);
  };

  return (
    <div className={classes.root}>
      <Helmet>
        <title>{appName || "CliqBR"} - Recuperar Senha</title>
        <link rel="icon" href={appLogoFavicon || "/default-favicon.ico"} />
      </Helmet>
      <Container component="main" maxWidth="xs" style={{ display: "flex", justifyContent: "center" }}>
        <CssBaseline />
        <Paper className={classes.paper}>
          <MailOutline style={{ fontSize: 60, color: "#0067E3", marginBottom: 16 }} />
          <Typography variant="h5" gutterBottom>Recuperar Senha</Typography>
          <Typography variant="body2" color="textSecondary" style={{ marginBottom: 24 }}>
            Digite o e-mail cadastrado e enviaremos um link para você redefinir sua senha.
          </Typography>
          <form style={{ width: "100%" }} onSubmit={handleSubmit}>
            <TextField variant="outlined" margin="normal" required fullWidth id="email" label="E-mail" name="email" autoComplete="email" autoFocus value={email} onChange={(e) => setEmail(e.target.value)} />
            <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit} disabled={loading}>
              {loading ? <CircularProgress size={24} color="inherit" /> : "Enviar Link"}
            </Button>
            <Link component={RouterLink} to="/login" variant="body2">Lembrou a senha? Voltar para o Login</Link>
          </form>
        </Paper>
      </Container>
    </div>
  );
};

export default PasswordForget;
